import React from 'react';
import {Stack, Typography, Tabs, Tab, Skeleton} from '@mui/material';

interface Filter {
  name: string;
  data: Array<{ name: string; id: string }>;
  wait?: string;
}

interface FastFiltersProps {
  schema?: { filters?: boolean };
  fastFilters: Filter[];
  fastFilterValue: Record<string, any>;
  handleChangeFastFilter: (
    newValue: number,
    index: number,
    filter: Filter,
    filterItem?: { name: string; id: string }
  ) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const FastFilters: React.FC<FastFiltersProps> = ({
                                                   schema,
                                                   fastFilters,
                                                   fastFilterValue,
                                                   handleChangeFastFilter,
                                                   disabled = false,
                                                   isLoading = false,
                                                 }) => {

  return (
    <Stack
      direction={'column'}
      sx={{
        pointerEvents: disabled || isLoading ? 'none' : 'auto',
        opacity: disabled || isLoading ? 0.5 : 1,
        background: '#fff',
        borderRadius: '10px',
        boxShadow: '0px 0px 10px -5px #00000091',
        p: '0px 10px',
        m: '10px',
        marginTop: '5px',
        marginBottom: '0px',
        minHeight: '48px',
      }}
    >
      {!fastFilters.length ?
        <>
        <Stack
          direction={'row'}
          alignItems={'center'}
          gap={2}
        >
          <Skeleton width={80} height={48} />
          <Skeleton width={80} height={48} />
          <Skeleton width={80} height={48} />
          <Skeleton width={80} height={48} />
          <Skeleton width={80} height={48} />
          <Skeleton width={80} height={48} />
        </Stack>

        </>
      : <>
        {fastFilters.map((filter, index) => {
          let selectedWaitedFilter = 0;
          if (filter?.wait) {
            const waitedFilter = Object.keys(fastFilterValue).filter((item) => {
              return fastFilterValue[`${item}`]?.column === filter?.wait;
            });
            if (fastFilterValue[parseInt(waitedFilter[0])]?.selected) {
              selectedWaitedFilter = 1;
            }
          }

          return filter?.wait && !selectedWaitedFilter ? (
            <React.Fragment key={index} />
          ) : (
            <Stack
              direction={'row'}
              key={index}
              alignItems={'center'}
              gap={2}
              sx={{
                borderTop: index ? '1px solid #ececec' : '',
              }}
            >
              <Typography
                variant={'h6'}
                sx={{
                  fontSize: '15px',
                  fontWeight: 'bolder',
                }}
              >
                {filter?.name}:
              </Typography>

              <Tabs
                value={
                  fastFilterValue[`${index}` as keyof {}]?.selected
                    ? fastFilterValue[`${index}` as keyof {}].selected
                    : 0
                }
                onChange={(event, newValue) => {
                  handleChangeFastFilter(
                    newValue,
                    index,
                    filter,
                    filter?.data[newValue - 1]
                  );
                }}
                aria-label="basic tabs example"
                sx={{
                  '& .MuiTab-root.Mui-selected': {
                    background: 'rgba(0,0,0,0.04)',
                  },
                }}
              >
                <Tab label={'All'} id={'0'} aria-controls={'0'} />

                {filter.data.map((filterItem, itemIndex) => (
                  <Tab
                    key={itemIndex}
                    label={filterItem?.name}
                    id={filterItem?.id}
                    aria-controls={filterItem?.id}
                  />
                ))}
              </Tabs>
            </Stack>
          );
        })}
      </> }


    </Stack>
  );
};

export default FastFilters;
